import React, { ReactElement, useEffect, useMemo, useState } from "react";

import {
  Box,
  BoxProps,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from "@chakra-ui/react";
import { useSettingsContext } from "../contexts/SettingsContext";
import APButton from "../components/APButton";
import { useVocabIntl } from "../hooks/useVocabTranslation";

function APResultDialog({
                          children,
                          open,
                          title,
                          onNext,
                          footer,
                          footerJustifyContent,
                          preventCloseOnEsc
                        }: {
  children: any;
  open: boolean;
  title: string | ReactElement;
  onNext?: any;
  footer?: React.ReactNode;
  footerJustifyContent?: BoxProps["justifyContent"];
  preventCloseOnEsc?: boolean;
}) {
  const [isOpen, setOpen] = useState(false);
  const { avatar } = useSettingsContext();
  const {APFormattedMessage}=useVocabIntl()

  useEffect(() => {
    setOpen(open);
  }, [open]);

  const onContinue = () => {
    onNext();
  };

  const renderFooter = useMemo(() => {
    if (footer) {
      return footer;
    } else {
      return (
        <APButton onClick={() => onContinue()}>
          <APFormattedMessage id={"continue-button"} />
        </APButton>
      );
    }
  }, [footer, onContinue]);

  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      closeOnEsc={!preventCloseOnEsc}
    >
      <ModalOverlay>
        <ModalContent>
          <ModalHeader>
            <Image src={`${process.env.REACT_APP_BASE_URL}/avatars/${avatar || "fire"}.svg`} width={"4rem"}
                   position={"absolute"} height={"4rem"} top={0} left={"50%"} transform={"translate(-50%, -50%)"} />
            <Box height={"1.5rem"} />
            <Text fontSize={["xl", "3xl"]} fontWeight={"bold"} textAlign={"center"}>
              {title}
            </Text>
          </ModalHeader>
          <ModalBody>{children}</ModalBody>
          <ModalFooter>
            {renderFooter}
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
}

export default APResultDialog;
